import GeneralModal from "../../../../components/GeneralModal/GeneralModal";
import { toast } from "react-toastify";
import { useEquipmentActivateMutation } from "../../../../store/builder/inspections.api";
import { useTranslation } from "../../../../hooks/useTranslation";
const ActivateEquipmentModal = ({
    equipment,
    setIsOpen,
    getEquipmentsInitial
}) => {
    const [
    activate,
    { isLoading: activateEquipmentIsLoading },
  ] = useEquipmentActivateMutation();
    const {t} = useTranslation();
    const handleActivate = () => {
        activate(equipment?.id).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }

    return (
        <GeneralModal
            title={t('equipmentTable.modals.activate.title')}
            onClose={() => setIsOpen(false)}
            onSubmit={handleActivate}
            submitTitle={t('equipmentTable.actions.activate')}
            btnType='save'
            disableSubmit={activateEquipmentIsLoading}
        >
            <div className='modal__content-body'>
                <p>{t('equipmentTable.messages.activateEquipment')}</p>
            </div>
        </GeneralModal>
    )
}

export default ActivateEquipmentModal;